import { FC } from 'react';
import { ImageAttachment } from '../../pages/Chat/Chat/types';

const Image: FC<ImageAttachment> = ({ url, alt }) => {
    return <img className="max-w-full h-auto my-2 object-contain rounded" src={url} alt={alt} />;
};

export default Image;
